<template>
  <div class="textLeft">
    <!-- <el-breadcrumb separator-class="el-icon-arrow-right" class="mb20">
      <el-breadcrumb-item :to="{ path: '/admin/statistics/ProjectStatistics' }">统计首页</el-breadcrumb-item>
      <el-breadcrumb-item>按物种、仪器、疾病、组织器官、细胞类型统计项目数和数据量（列表）</el-breadcrumb-item>
    </el-breadcrumb> -->
    <el-select v-model="candval" placeholder="请选择" @change="handleTitle">
      <el-option
        v-for="item in candArr"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <!-- <el-button class="submitbtn ml5" @click="handleChangecand">Search</el-button> -->
    <el-card class="box-card tablecard mt10" shadow="never">
      <div slot="header" class="clearfix textLeft">
        <span><i class="fa fa-gift fs14" /> {{titleVal}} </span>
      </div>
      <div>
        <div class="mb10 textRight">
          Search: <el-input size="medium" v-model="searchkey" placeholder="" class="searchInput mr5" clearable></el-input>
            <el-button class="submitbtn" @click="handleSearch">Search</el-button>
        </div>
        <el-table
          v-loading="loading"
          @sort-change="handleSort"
          :data="sData"
          height="800"
          border
          stripe
          style="width: 100%">
          <el-table-column
            prop="object_name"
            :label="titleArr[candval]"
            width="250"
            show-overflow-tooltip="isOverflow"
            header-align="center"
            sortable>
          </el-table-column>
          <el-table-column label="The number of projects" header-align="center">
            <el-table-column
              prop="projects_all"
              label="All"
              header-align="center"
              align="right"
              sortable>
            </el-table-column>
            <el-table-column
              prop="projects_submit"
              label="Submmitted"
              header-align="center"
              align="right"
              sortable>
            </el-table-column>
            <el-table-column
              prop="projects_spublic"
              label="Submitted Public"
              header-align="center"
              align="right"
              sortable>
            </el-table-column>
          </el-table-column>
          <el-table-column label="Data size(GB)" header-align="center">
            <el-table-column
              prop="datasize_all"
              header-align="center"
              align="right"
              label="All"
              sortable>
            </el-table-column>
            <el-table-column
              prop="datasize_submit"
              label="Submmitted"
              header-align="center"
              align="right"
              sortable>
            </el-table-column>
            <el-table-column
              prop="datasize_spublic"
              label="Submitted Public"
              header-align="center"
              align="right"
              sortable>
            </el-table-column>
          </el-table-column>
          <!-- <el-table-column
            v-for="(item, index) in tableHeaders"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :show-overflow-tooltip="item.isOverflow">
          </el-table-column> -->
        </el-table>
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :total="allNum"
          :page-size="pageSize"
          @current-change="handleChangepage"
          class="pagination mb10">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getStatProjectByObject } from '@/api'
import echarts from 'echarts'
export default {
  name: 'statistics',
  data() {
    return {
      sData: [],
      loading: false,
      allNum: 0,
      pageSize: 20,
      searchkey: '',
      isOverflow: true,
      tableHeaders: [
        { label: 'Disease', prop: 'country', isOverflow: true },
        { label: 'The number of projects', prop: 'name', isOverflow: true },
        { label: 'Data size(GB)', prop: 'address', isOverflow: true }
      ],
      candArr: [{
        value: 1,
        label: 'Species'
      }, {
        value: 2,
        label: 'Tissue'
      }, {
        value: 3,
        label: 'Cell'
      }, {
        value: 4,
        label: 'Disease'
      }, {
        value: 9,
        label: 'Instrument'
      }],
      candval: 1,
      ajax_data: {
        search:{
          type_code: 1,
          sub: ''
        },
        page:{
          startPage: 1,
          pageLength: 20
        },
        order:{
          item: 'projects_all',
          type: 'desc'
        }
      },
      titleVal: 'Species',
      titleArr: ['', 'Species', 'Tissue', 'Cell Type', 'Disease', '', '', '', '', 'Instrument'],
      orderConvert: {
        ascending: 'asc',
        descending: 'desc'
      }
    }
  },
  mounted() {
    
  },
  created() {
    getStatProjectByObject(this.ajax_data).then(res => {
      this.sData = res.result
      this.allNum = res.count
    })
  },
  methods: {
    handleChangepage(val) {
      this.loading = true
      this.ajax_data.page.startPage = val
      getStatProjectByObject(this.ajax_data).then(res => {
        this.loading = false
        this.sData = res.result
        this.allNum = res.count
      })
    },
    handleSort(column, prop, order) {
      this.loading = true
      this.ajax_data.order.item = column.prop
      this.ajax_data.order.type = this.orderConvert[column.order]
      if (column.order !== null && column.prop !== null) {
        getStatProjectByObject(this.ajax_data).then(res => {
          this.loading = false
          this.sData = res.result
          this.allNum = res.count
        })
      } else {
        this.loading = false
      }
    },
    handleSearch() {
      this.loading = true
      this.ajax_data.search.sub = this.searchkey
      getStatProjectByObject(this.ajax_data).then(res => {
        this.loading = false
        this.sData = res.result
        this.allNum = res.count
      })
    },
    handleTitle() {
      this.titleVal = this.titleArr[this.candval]
      this.ajax_data.search.type_code = this.candval
      getStatProjectByObject(this.ajax_data).then(res => {
        this.sData = res.result
        this.allNum = res.count
      })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
